import React, { useEffect, useState } from "react";
import axios from "../../config/authaxios";
import Dropdown from "../../css/dropdown.module.scss";
import { Button, Card, Paper, Stack, Typography } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import Body from "../../ui/Body";
import { useStyles } from "../../theme/theme";
import '../../css/table.scss'
import { useNavigate } from "react-router-dom";
import DateTimePickerStartViewRenderers from "./DateTimePickerStart";
import DateTimePickerEndViewRenderers from "./DateTimePickerEnd";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


function History() {
  const navigate = useNavigate()


  const [coupons, setCoupons] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(15);

  const [isMore, setIsMore] = useState(false);
  // const [load, setLoad] = useState(false);
  const [nodata, setNodata] = useState(false);
  const classes = useStyles();
  const [pageSize, setPageSize] = useState(25);
  const [payment, setPayment] = useState('freecash')
  const [process, setProcess] = useState('3')
  const [startTime, setStartTime] = useState()
  const [endTime, setEndTime] = useState()
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [id, setId] = React.useState('')
  const [statusData, setStatusData] = useState(null)
  const [load, setLoad] = useState(false)
  const [publishers, setPublishers] = useState([]);
  const [selectedPublisher, setSelectedPublisher] = useState(null);

  useEffect(() => {
    fetchCoupon();
    fetchPublisher();
  }, [payment, limit, process, selectedPublisher]);

  const fetchCoupon = () => {
    setPage(0);
    //console.log("page-->",page)
    setNodata(true);
    setIsMore(false);
    let query = {};

    if (page === 0 || page) {
      query.page = page;
      // temp += "page=" + page + "&";
    }

    if (limit) {
      query.limit = limit;
      // temp += "limit=" + limit + "&";
    }
    // temp += "type=" + isType + "&";
    query.payment_via = payment;
    query.process_status = process;
    query.s_date = startTime;
    query.e_date = endTime;
    if (selectedPublisher && selectedPublisher !== "All") {
      query.publisher_id = selectedPublisher._id;
    }

    //console.log("-->temp-->",temp)
    axios.post(`/admin/payment/histories`, query).then((res) => {
      //console.log(res.data.response);
      setNodata(true)
      let data = res.data.response;

      if (res.data.status) {
        setCoupons(data);
        if (data && data.length < limit) {
          setIsMore(true);
        }
        // if (data.length === 0) {
        //   setNodata(true);
        // } else {
        //   setNodata(false);
        // }
        setNodata(false)

        setPage(1);
      }
    });
  };

  const fetchPublisher = () => {
    axios.get(`/admin/publishers/list`).then((res) => {
      setPublishers([{ name: "All" }, ...res?.data?.response])
    });
  };

  const fetchCouponbySearch = () => {
    setPage(0);
    //console.log("page-->",page)
    setNodata(true);
    setIsMore(false);
    let query = {};

    if (page === 0 || page) {
      query.page = 0;
      // temp += "page=" + page + "&";
    }

    if (limit) {
      query.limit = limit;
      // temp += "limit=" + limit + "&";
    }
    // temp += "type=" + isType + "&";
    query.payment_via = payment;
    query.process_status = process;
    query.s_date = startTime;
    query.e_date = endTime;

    //console.log("-->temp-->",temp)
    axios.post(`/admin/payment/histories`, query).then((res) => {
      //console.log(res.data.response);
      setNodata(true)
      let data = res.data.response;

      if (res.data.status) {
        setCoupons(data);
        if (data && data.length < limit) {
          setIsMore(true);
        }
        // if (data.length === 0) {
        //   setNodata(true);
        // } else {
        //   setNodata(false);
        // }
        setNodata(false)

        setPage(1);
      }
    });
  };


  const Showmore = () => {
    setNodata(true);
    setIsMore(false);
    let temp = {};

    if (page === 0 || page) {
      // temp += "page=" + page + "&";
      temp.page = page;
    }

    if (limit) {
      // temp += "limit=" + limit + "&";
      temp.limit = limit;
    }
    temp.payment_via = payment;
    temp.process_status = process;
    temp.s_date = startTime;
    temp.e_date = endTime;

    //console.log("-->temp-->",temp)
    axios.post(`/admin/payment/histories`, temp).then((res) => {
      let data = res.data.response;
      //console.log("-->",data)
      let temp = [...coupons, ...data];
      if (data.length < limit) {
        setIsMore(true);
      }
      setCoupons(temp);
      setNodata(false);
      setPage(page + 1);
      // //console.log(res.data);
    });
  };

  const searchHandler = () => {

    setPage(0)
    fetchCouponbySearch()
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const checkStatus = (paymentId) => {
    setLoad(true)
    const query = {
      paymentId
    }

    axios.post(`/admin/payment/check-order-status/upi-voucher`, query).then((res) => {
      // console.log(res);
      //  alert(res.data.message)

      setStatusData(res.data)
      setLoad(false)





    });

  }

  const changeStatusHandler = () => {
    const query = {
      paymentId: id
    }

    axios.post(`/admin/payment/refund/amount`, query).then((res) => {
      // console.log(res);
      alert(res.data.message)
      setOpen(false);
      setPage(0)
      setProcess(5)


    });

  }





  return (
    <>
      {/* <section className={CardStyle.main}> */}

      <Body >

        <Typography style={{ color: "#646777", fontSize: "1.7rem", width: "50%" }}>Order History</Typography>
        <Stack spacing={2} direction='row' sx={{ mb: 2 }}>
          <DateTimePickerStartViewRenderers setStartTime={setStartTime} />
          <DateTimePickerEndViewRenderers setEndTime={setEndTime} />
          {startTime && endTime && <Button variant="contained" onClick={searchHandler}>Search</Button>}
        </Stack>
        <Stack spacing={2} direction='row'>
          <div className={Dropdown.dropdown}>
            <Button variant="contained" disabled={coupons.length > 0 && !isMore ? false : true} color='info' sx={{ my: 2 }} className={Dropdown.dropbtn} onClick={Showmore}>More</Button>
          </div>
          <div className={Dropdown.dropdown} style={{ cursor: "pointer" }}>
            <Button variant="contained" color='info' sx={{ my: 2 }}>limit:{limit}</Button>
            <div className={Dropdown.dropdown_content}>
              <a className={limit === 25 ? "disabled" : "notDisabled"} onClick={() => { setLimit(25); setPage(0) }}>25</a>
              <a disabled={limit === 50 ? true : false} onClick={() => { setLimit(50); setPage(0) }}>50</a>
              <a disabled={limit === 100 ? true : false} onClick={() => { setLimit(100); setPage(0) }}>100</a>
              <a disabled={limit === 500 ? true : false} onClick={() => { setLimit(500); setPage(0) }}>500</a>
              <a disabled={limit === 1000 ? true : false} onClick={() => { setLimit(1000); setPage(0) }}>1000</a>
            </div>
          </div>

          <div className={Dropdown.dropdown} style={{ cursor: "pointer", zIndex: "2" }}>
            <Button variant="contained" color='info' sx={{ my: 2 }}>Payment:{payment}</Button>
            <div className={Dropdown.dropdown_content}>
              <a onClick={() => { setPayment('freecash'); setPage(0) }}>Freecash</a>
              <a onClick={() => { setPayment("phonepe"); setPage(0) }}>Phonepe</a>

            </div>
          </div>

          <div className={Dropdown.dropdown}>
            <Button variant="contained" color='info' sx={{ my: 2 }}>Status:{process == '1' ? 'Started' : process == '2' ? 'Deducted' : process == '3' ? 'Success' : process == '4' ? 'Refunded' : "Error"}</Button>
            <div className={Dropdown.dropdown_content} style={{ cursor: "pointer" }}>
              <a onClick={() => { setProcess('1'); setPage(0) }}>Started</a>
              <a onClick={() => { setProcess("2"); setPage(0) }}>Deducted</a>
              <a onClick={() => { setProcess("3"); setPage(0) }}>Success</a>
              <a onClick={() => { setProcess("4"); setPage(0) }}>Refunded</a>
              <a onClick={() => { setProcess("5"); setPage(0) }}>Error</a>

            </div>
          </div>

          <div className={Dropdown.dropdown}>
            <Button variant="contained" color="info" sx={{ my: 2 }}>
              Publisher: {selectedPublisher?.name || "Select Publisher"}
            </Button>
            <div className={Dropdown.dropdown_content} style={{ cursor: "pointer" }}>
              {publishers?.map((pub) => (
                <a
                  key={pub._id}
                  onClick={() => {
                    setSelectedPublisher(pub);
                    setPage(0);
                  }}
                >
                  {pub.name}
                </a>
              ))}
            </div>
          </div>


        </Stack>

        {coupons.length > 0 ? <div style={{ width: "75vw", height: "35vw", overflow: "auto" }}>
          <table style={{ borderCollapse: "collapse" }}>
            <thead style={{ background: "#DC8449", color: "#fff", position: "sticky", top: "0px" }}>
              <tr>
                <th>S. No.</th>
                <th>Publisher Name</th>
                <th>Proreward User id</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>Amount</th>
                <th>Free Cash Amount</th>
                <th>Order Id</th>
                <th>Payment Via</th>
                <th>Payment Status</th>
                {(process == '5' || process == '2') && <th>Change Status</th>}
                {(process == '2') && <th>see Status</th>}
                <th>Process Status</th>
                <th>return_at</th>
                <th>v_s_message</th>
                <th>Is Free Cash</th>
                <th>Free Cash Amount</th>
                <th>Free Cash txn id</th>
                <th>SKU</th>
                <th>Used at</th>
                <th>Paid at</th>

              </tr>
            </thead>
            <tbody style={{ overflowX: "auto" }}>
              {coupons.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.publisher_id?.name}</td>
                    <td>{item?.p_user_id}</td>
                    <td>{item?.mobile}</td>
                    <td>{item?.email}</td>
                    <td>{item?.amount}</td>
                    <td>{item?.free_cash_amount}</td>
                    <td style={{ textDecorationLine: "underline", cursor: "pointer" }} onClick={() => navigate(`/history-detail?orderId=${item?.order_id}`)}>{item?.order_id}</td>
                    <td>{item?.payment_via}</td>
                    <td>{item?.status}</td>
                    {(process == '5' || process == '2') && <td style={{ padding: "10px 10px" }}><Button variant="contained" color="error" onClick={() => { setId(item?._id); setOpen(true) }}>Return</Button></td>}
                    {(process == '2') && <td style={{ padding: "10px 10px" }}>{item.v_cat_type == 4 ? <Button variant="contained" color="error" onClick={() => { setId(item?._id); setOpen2(true); checkStatus(item?._id) }}>see</Button> : "---"}</td>}
                    <td>{item?.process_status}</td>
                    <td>{item?.return_at}</td>
                    <td>{item?.v_s_message}</td>
                    <td>{item?.is_free_cash}</td>
                    <td>{item?.free_cash_amount}</td>
                    <td>{item?.free_cash_txn_id}</td>
                    <td>{item?.sku}</td>
                    <td>{item?.used_at}</td>
                    <td>{item?.paid_at}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div> : (
          !nodata && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "200px 0" }}>
              No Data Available
            </div>
          )
        )

        }


        {nodata && <section style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "200px 0" }}>Loading...</section>}
        {/* <Paper sx={{
          bgcolor: '#fff',
          '& .super-app-theme--header': {
            bgcolor: '#DC8449',
            color: '#fff',
          },
        }} elevation={0}>

          {console.log("coupons-->", coupons)}
          <DataGrid
            // className={classes.root}
            sx={{
              border: 0,
            }}
            // hideFooterPagination
            // // getRowHeight={() => 'auto'}
            // autoHeight
            rows={coupons}
            columns={CouponsColomns}
            getRowId={(row) => row._id}
          // disableSelectionOnClick
          // disableRowSelectionOnClick
          // experimentalFeatures={{ newEditingApi: true }}
          // pagination={false}
          // pageSize={pageSize}
          // paginationPageSize={500}

          // disableColumnSelector
          />
        </Paper> */}
        {/* <Button disabled={coupons.length > 0 && !isMore?false:true} variant="contained" color='info' sx={{ my: 2 }} onClick={Showmore}>More</Button> */}
      </Body>


      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you Sure?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to Return the Amount
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Disagree</Button>
          <Button onClick={changeStatusHandler} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open2}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Order Details"}
        </DialogTitle>
        <DialogContent>
          {load ? "loading..." : <pre>{JSON.stringify(statusData, null, 2)}</pre>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose2}>close</Button>
          {/* <Button onClick={changeStatusHandler} autoFocus>
            Agree
          </Button> */}
        </DialogActions>
      </Dialog>

      {/* </section> */}
    </>
  );
}

export default History;